import React, { useRef, useState } from 'react';
import MotionAccuracy from './MotionAccuracy';
import { FiCheck, FiCopy } from 'react-icons/fi';

export default function MotionTrackReference({ trackId, compact = false, reviewedCount, accuracy }) {
  const [status, setStatus] = useState('');
  const value = useRef(null);
  const disclosure = useRef(null);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(trackId);
      if (value.current) setStatus('copied');
    } catch {
      // The complete ID stays selectable when clipboard access is unavailable.
      if (!value.current) return;
      if (disclosure.current) disclosure.current.open = true;
      const range = document.createRange();
      range.selectNodeContents(value.current);
      const selection = window.getSelection();
      selection?.removeAllRanges(); selection?.addRange(range);
      setStatus('manual');
    }
  };
  if (!trackId) return null;
  return <div className={`cr-motion-track-reference${compact ? ' cr-motion-track-reference--compact' : ''}`} onKeyDown={(event) => {
    // Space on Copy should activate that button, not submit a Not sure vote.
    if (event.key === ' ' || event.key === 'Spacebar') event.stopPropagation();
  }}>
    {compact ? <details ref={disclosure} className="cr-motion-track-identity"><summary aria-label="Show full motion track ID">Track {trackId.length > 20 ? `${trackId.slice(0, 8)}…${trackId.slice(-4)}` : trackId}</summary><code ref={value}>{trackId}</code></details> : <div className="cr-motion-track-identity"><span>Motion track ID</span><code ref={value}>{trackId}</code></div>}
    <button type="button" className="cr-text-button" aria-label="Copy motion track ID" onClick={copy}>{status === 'copied' ? <FiCheck aria-hidden="true" /> : <FiCopy aria-hidden="true" />}<span>{status === 'copied' ? 'Copied' : 'Copy ID'}</span></button>
    {compact && reviewedCount !== undefined && <span className="cr-motion-personal-count" aria-label="Your motion review count" aria-live="polite" title="Completed Real motion and False alarm answers. Not sure is excluded.">You: <strong>{Number.isFinite(reviewedCount) ? reviewedCount.toLocaleString('en-GB') : '—'}</strong><MotionAccuracy accuracy={accuracy} compact /></span>}
    <span className={`cr-motion-track-copy-status${status === 'manual' ? '' : ' cr-motion-track-copy-status--quiet'}`} role="status">{status === 'copied' ? 'Motion track ID copied.' : status === 'manual' ? 'Copy the selected ID to include it in your report.' : ''}</span>
  </div>;
}
